// this is an autogenerated file from DesignSystem/ImageComparison/Content/Sections/Section/Content/PreviewImage/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ImageComparison_Content_Sections_Section_Content_PreviewImage($resource_id: StringOrNumber!) {
  vaxiom_resource_object_meta(resource_id: $resource_id, resource_type: image) {
    name
    content_type
    size
    url
    preview_url
  }
}

`